import { useState, useEffect } from "react";
import { useI18n } from "../../i18n";
import { getContentByLocale } from "../../content";

import { Link } from "react-router-dom";
import "./CookieBanner.css";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const { locale } = useI18n();
  const content = getContentByLocale(locale);
  const currentVersion = content.privacy.version;

  useEffect(() => {
    const acceptedVersion = localStorage.getItem("cookie-consent-version");
    
    // If no version accepted or if the version is different from current, show banner
    if (acceptedVersion !== currentVersion) {
      setIsVisible(true);
    }
  }, [currentVersion]);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent-version", currentVersion);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          {content.cookieConsent.message}{" "}
          <Link to="/privacidade" className="cookie-link">
            {content.privacy.title}
          </Link>
        </p>
        <button onClick={handleAccept} className="cookie-btn">
          {content.cookieConsent.button}
        </button>
      </div>
    </div>
  );
}
